// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2382":"9f6d9f45","7322":"48f99088"}[chunkId] + ".css";
};